import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core'
import { provideState } from '@ngrx/store'
import { provideEffects } from '@ngrx/effects'

import { UPDATER_FEATURE_TOKEN } from './constants/updater.constants'
import { updaterReducer } from './store/reducers/updater.reducer'
import { UpdaterEffects } from './store/effects/updater.effects'
import { IosUpdaterService } from '@core/services/updater/services/ios-updater.service'

export function provideUpdater(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(UPDATER_FEATURE_TOKEN, updaterReducer),
    provideEffects([UpdaterEffects]),
    IosUpdaterService
  ])
}
